import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

export const supportedLanguages = [
  { code: 'en', name: 'English' },
  // { code: 'ja', name: '日本語' },
] as const

export type SupportedLanguage = (typeof supportedLanguages)[number]['code']

// detect language from ip
// const detectLanguageFromIP = async () => {
//   try {
//     const response = await fetch('https://ipapi.co/json/')
//     const data = await response.json()
//     const countryCode = data.country_code.toLowerCase()

//     const languageMap: Record<string, SupportedLanguage> = {
//       jp: 'ja',
//     }

//     return languageMap[countryCode] || 'en'
//   } catch (error) {
//     console.error('Failed to detect language from IP:', error)
//     return 'en'
//   }
// }

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: supportedLanguages.map((lang) => lang.code),
    detection: {
      order: ['localStorage', 'querystring', 'cookie', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: {},
  })

// const checkAndSetInitialLanguage = async () => {
//   const storedLanguage = localStorage.getItem('i18nextLng')

//   if (!storedLanguage) {
//     const detectedLang = await detectLanguageFromIP()
//     i18n.changeLanguage(detectedLang)
//   }
// }

// checkAndSetInitialLanguage()

export default i18n
